console.log('✅ home-page-trending-listings.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';

import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

export async function buildComponentHomePageMiddleSection() {
  console.log(
    `🔄 Building Component: HomePageMiddleSection - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    //// ✅ Fetch all translations in parallel
    //const [
    //    lblPaymentProtection,
    //    lblGlobalSourcing,
    //    lblBecomeASeller,
    //    linkPaymentProtection,
    //    linkSell

    //] = await Promise.all([
    //    getTextTranslationByKey("keyPaymentProtection", lang),
    //    getTextTranslationByKey("keyGlobalSourcing", lang),
    //    getTextTranslationByKey("keyBecomeASeller", lang),

    //    getLinksTranslationByKey("keyPaymentProtection", lang),
    //    getLinksTranslationByKey("keySell", lang)
    //]);

    await initTempTextTranslator(appState.SiteLanguageCookie);
    await initTempLinksTranslator(appState.SiteLanguageCookie);
    // const tempTranslator = await loadTextTranslations(lang);

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyPaymentProtection: lblPaymentProtection,
      keyGlobalSourcing: lblGlobalSourcing,
      keyBecomeASeller: lblBecomeASeller,
      keySell: lblSell,
    } = _tempTextTranslator;

    const { keyPaymentProtection: linkPaymentProtection, keySell: linkSell } = _tempLinksTranslator;

    // Build the trending listings HTML
    const html = `
            <center>
                <div class="payment-protection-wrapper">

        <div class="payment-protection-grid">

            <div class="payment-protection-Thumbnail">

                    <a href="${linkPaymentProtection}">
                    <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pg/hm/guarantee.png" width="426" height="240" alt="${lblPaymentProtection}" loading="lazy">

                    <h4>
                        ${lblPaymentProtection}
                    </h4>
                </a>
                </div>
            <div class="payment-protection-Thumbnail">
                <a href="${linkSell}">
                    <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pg/hm/shipping.jpg" width="426" height="240" alt="${lblGlobalSourcing}" loading="lazy" />

                    <h4>

                         ${lblGlobalSourcing}
                    </h4>

                </a>

                </div>
            <div class="payment-protection-Thumbnail">
                <a href="${linkSell}">
                    <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pg/hm/seller.jpg" width="426" height="240" alt="${lblBecomeASeller}" loading="lazy">

                    <h4>

                        ${lblBecomeASeller}
                    </h4>
                    </a>

                </div>




            </div>

        </div>

            </center>
            <br />             
        `;

    console.log('✅ HomePageMiddleSection built successfully.');

    // Register event listeners
    // registerEventListenerToAttach(attachEventListenersHomePageMiddleSection);

    return html;
  } catch (err) {
    console.error('❌ Error building HomePageMiddleSection:', err);
    return '<div>Error loading HomePageMiddleSection listings</div>';
  }
}

function attachEventListenersHomePageMiddleSection() {
  try {
    console.log('✅ HomePageMiddleSection event listeners attached.');
    // Placeholder for future event listeners if needed
  } catch (error) {
    console.error('❌ Error attaching event listeners to HomePageMiddleSection:', error);
  }
}
